export const selectCameraState = (state) => state.camera;
